// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__NqsCw"};